<form novalidate (ngSubmit)="saveCard()" [formGroup]="cardForm" class="card" [class.card-error]="cardError">
  <lin-form-label>{{ 'FIELDS.NAME' | translate }}</lin-form-label>
  <mat-form-field>
    <input matInput type="text" formControlName="name" />
    <mat-error>
      <lin-form-field-error></lin-form-field-error>
    </mat-error>
  </mat-form-field>

  <ngx-stripe-card [stripe]="stripe" [options]="cardOptions" (change)="cardHandler($event)"></ngx-stripe-card>
  @if (cardError) {
  <span class="card-error-text">{{ cardError }}</span>
  }
  <lin-form-submit-button type="submit" [isDisabled]="isSubmitting || cardError || !cardComplete" [isLoading]="paymentMethodCreating"
    >{{ 'BUTTONS.SAVE_CARD' | translate }}</lin-form-submit-button
  >
</form>
